'use client';
import { PageHero } from '@/components/general/PageHero';
import PageWrapper from '@/components/general/PageWrapper';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import React from 'react';
import AllServicesHero from './AllServicesHero';
import HomeServices from '../../home/HomeContent/HomeServices';
import { AppPromo } from '../../home/HomeContent/AppPromo';
import { ResponseType, ServiceCategory } from '@/commonTypes';

export default function AllServicesContent({ data }: { data?: ResponseType<ServiceCategory> }) {
  console.log('data==', data);
  return (
    <>
      <PageWrapper className={`p-0`}>
        <ViewportWrapper className={`w-full`}>
          <PageHero>
            <AllServicesHero />
          </PageHero>
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`w-full mt-0 section-paper p-0`}>
        <ViewportWrapper className={`container py-0`}>
          {data?.response && data?.response?.length != 0 ? (
            <HomeServices showHead={false} services={data?.response} />
          ) : (
            <p className={`card notFound mt-30px`}>سرویس یافت نشد.</p>
          )}
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`w-full mt-0`} style={{ backgroundColor: 'var(--paper)' }}>
        <ViewportWrapper className={`container`}>
          <AppPromo />
        </ViewportWrapper>
      </PageWrapper>
    </>
  );
}
